import { useEffect, useRef, useState } from 'react'
import { PixelCrop } from 'react-image-crop'
import { CropImageProps } from '../types'
import getCroppedImg from '../helpers/getCroppedImage'

type HookProps = Pick<CropImageProps, 'onChange' | 'zoom' | 'pan'>

const useCroppedImage = ({ onChange, zoom = 1, pan }: HookProps) => {
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>()
  const imageRef = useRef<HTMLImageElement | null>(null)
  const [url, setUrl] = useState('')

  useEffect(() => {
    void (async () => {
      if (!completedCrop || !imageRef.current) return

      const blob = await getCroppedImg(
        imageRef.current,
        completedCrop,
        'image/jpeg',
        zoom,
        pan?.x ?? 0,
        pan?.y ?? 0,
      )
      const url = URL.createObjectURL(blob)
      setUrl(url)
      onChange?.(url)
    })()

    return () => {
      url && URL.revokeObjectURL(url)
    }
  }, [completedCrop, imageRef.current, onChange, zoom, pan?.x, pan?.y])

  return [imageRef, setCompletedCrop] as const
}

export default useCroppedImage
